export default "__VITE_ASSET__42c43743__"